/* The control cluster every row on the pulpit carries — the mock's `.ta`, `.btn.sm` and `.tb`.
 *
 * Geometry only for the primary: the TREATMENT comes from `shared/ui/inkButton.module.css` and
 * nothing is declared on both sides. A declaration living in a shared module and a page's own is
 * settled by chunk order, which differs between the dev server and the build — this repo has paid
 * for that once already, and `emberButton.module.css` carries the write-up. */

.controls {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: var(--space-1);
  align-items: flex-end;
  margin-inline-start: auto;
}

/* `.btn.sm` — 28px, 12px/700, 8px radius. The gap is the desk's, between a card foot's glyph and
 * its word; a row's primary draws no glyph and the gap never applies. */
.primary {
  gap: var(--space-6px);
  height: 28px;
  padding: var(--space-0) var(--space-10px);
  font-size: var(--fs-label);
  font-weight: var(--fw-bold);
  letter-spacing: var(--ls-heading);
  text-decoration: none;
  border-radius: var(--radius-8px);
}

/* The three controls, in one row. */
.cluster {
  display: flex;
  gap: var(--space-1);
  align-items: center;
}

/* `.tb` — a 30px square carrying one 14px mark. The hit target's floor is 30px, which is exactly
 * what this is, so no hit extender is needed. */
.iconButton {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: var(--text-2);
  cursor: pointer;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-8px);
  transition-duration: var(--dur-fast);
  transition-property: color, background;
  transition-timing-function: var(--ease);
}

.iconButton:hover {
  color: var(--text);
  background: var(--bg-chip);
}

/* `--accent` on a neutral, unfilled control: a neutral ring on a neutral edge is the one
 * combination that disappears. The two shared button treatments both do this, for this reason. */
.iconButton:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.iconMark {
  display: block;
  width: 14px;
  height: 14px;
}

/* The feedback card's foot: the cluster spans it, the primary at the start and the two responses at
 * the end (KANON "Karty zadań" `.cv-acts`). */
.spread {
  flex: 1;
  align-items: stretch;
  margin-inline-start: var(--space-0);
}

.spacer {
  flex: 1;
}

/* What the host sets beside the primary („Zobacz sesję"): a word, not a control of the cluster, so
 * it stands a step away from the button rather than at the cluster's 4px. */
.beside {
  display: inline-flex;
  margin-inline-start: var(--space-2);
}
